// import external dependencies
import 'jquery'
import 'custom-event-polyfill'
import 'nouislider'
import 'select2'
import 'cookieconsent'

// import local libs
import './util/htmlclass/_htmlclass';
import './util/htmlclass/useragent-html-classes';
import './util/swiper/swiper';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import pageTemplateRetailBanking from './routes/pageTemplateRetailBanking';
import pageTemplateRetailBankingSavings from './routes/pageTemplateRetailBankingSavings';
import pageTemplateDepositPage from './routes/pageTemplateDepositPage';
import pageTemplateLatestNews from './routes/pageTemplateLatestNews';
import pageTemplateContactsAndLocation from './routes/pageTemplateContactsAndLocation';
import pageTemplateCorporateBanking from './routes/pageTemplateCorporateBanking';
import pageTemplateCorporateBankingAccounts from './routes/pageTemplateCorporateBankingAccounts';
import pageTemplateExchangeRate from './routes/pageTemplateExchangeRate';

import pageTemplateKredit from './routes/pageTemplateKredit';
import pageTemplateKredit2 from './routes/pageTemplateKredit';

import pageTemplateStambeniKredit from './routes/pageTemplateStambeniKredit';


/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    // Retail Banking
    pageTemplateRetailBanking,
    // Retail Banking Savings
    pageTemplateRetailBankingSavings,
    // Deposit page
    pageTemplateDepositPage,
    // Non Resident Latest news
    pageTemplateLatestNews,
    // Contacts and Location
    pageTemplateContactsAndLocation,
    // Corporate Banking
    pageTemplateCorporateBanking,
    // Corporate Banking Accounts
    pageTemplateCorporateBankingAccounts,
    // Exchange Rates
    pageTemplateExchangeRate,
    // Kredit
    pageTemplateKredit,

    pageTemplateKredit2,

    pageTemplateStambeniKredit
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js